import React from "react";
import { Form, Col, ToggleButtonGroup, ToggleButton } from "react-bootstrap";

export default function DataTypePicker({ formData, setFormData, name }) {
    return (
        <Form.Group as={Col} className="d-flex flex-column col-12 col-xl-auto">
            <Form.Label>Data type</Form.Label>
            <ToggleButtonGroup
                type={"radio"}
                name="dataType"
                value={formData.dataType}
                onChange={value => setFormData({ ...formData, dataType: value })}
                className="ra-switcher">
                <ToggleButton id={`${name}-data-type-stream`} variant={"ra-dark-blue-outline"} disabled={!formData.station[0]?.stream} value={1}>
                    Stream
                </ToggleButton>
                <ToggleButton id={`${name}-data-type-ppm`} variant={"ra-dark-blue-outline"} value={2} disabled={!formData.station[0]?.ppm}>
                    Ratings
                </ToggleButton>
            </ToggleButtonGroup>
        </Form.Group>
    );
}
